/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S3_Item6Inputs */

const tr_hakkimizda_s3_item6 = /** @type {(inputs: Hakkimizda_S3_Item6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TanStack Start + Vite, modern React altyapısı`)
};

const en_hakkimizda_s3_item6 = /** @type {(inputs: Hakkimizda_S3_Item6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TanStack Start + Vite, modern React infrastructure`)
};

const de_hakkimizda_s3_item6 = /** @type {(inputs: Hakkimizda_S3_Item6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TanStack Start + Vite, moderne React-Infrastruktur`)
};

const ru_hakkimizda_s3_item6 = /** @type {(inputs: Hakkimizda_S3_Item6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TanStack Start + Vite, современная инфраструктура React`)
};

/**
* | output |
* | --- |
* | "TanStack Start + Vite, modern React infrastructure" |
*
* @param {Hakkimizda_S3_Item6Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s3_item6 = /** @type {((inputs?: Hakkimizda_S3_Item6Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S3_Item6Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s3_item6(inputs)
	if (locale === "de") return de_hakkimizda_s3_item6(inputs)
	if (locale === "ru") return ru_hakkimizda_s3_item6(inputs)
	return tr_hakkimizda_s3_item6(inputs)
});